import { formatMoney } from '../common'

class VariantSelector extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('change', this.onVariantChange)
    this.templateProductWrapper = this.closest('.template-product__wrapper')
    this.productWrapper = this.closest('.product__wrapper')
    this.productInfo = this.closest('.product__info')
    this.flexibleBundleWebComponent = document.querySelector('umg-flexible-bundle')
    if (this.querySelector('#pause-video-json')) {
      this.pauseInfo = JSON.parse(this.querySelector('#pause-video-json').textContent)
    }

    const upsellItem = this.closest('.cart-upsell__item-info')
    if (upsellItem) {
      this.cartUpsellPrice = upsellItem.querySelector('.cart-upsell__item-price')
    }

    if (this.closest('.card__quick-shop-overlay')) {
      this.productCard = this.closest('.card__quick-shop-overlay')
    } else {
      this.productCard = this.closest('.product_card')
    }
    if (this.pauseInfo) {
      this.checkPauseVariants()
    }
  }

  connectedCallback () {
    customElements.whenDefined('umg-flexible-bundle').then(() => {
      this.updateOptions()
      this.updateMasterId()

      if (this.currentVariant) {
        this.updateSelectedVariantIdFlexibleBundleProductCard()
      }
    })
  }

  onVariantChange () {
    if (this.productInfo) {
      this.productInfo.classList.add('loading')
    } else if (this.productCard) {
      // console.log('product card')
      this.productCard.classList.add('loading')
    }
    // TODO: do we need to updateOptions on every change or is it enough to run once on load?
    this.updateOptions()
    if (this.pauseInfo) {
      this.checkPauseVariants()
    }
    this.updateMasterId()
    this.toggleAddButton(true, '', true)

    // console.log('current variant', this.currentVariant)

    if (!this.currentVariant) {
      // should we redirect user to url of variant here??
      this.toggleAddButton(true, window.variantStrings.soldOut, true)
      this.setUnavailable()
    } else {
      this.updateVariantInput()
      if (this.flexibleBundleWebComponent) {
        this.updateSelectedVariantIdFlexibleBundleProductCard()
      } else if (this.templateProductWrapper) {
        this.updateMedia()
        this.updateURL()
        this.renderProductInfo()
      } else if (this.productWrapper) {
        this.updateMedia()
        this.renderProductInfo()
      } else if (this.productCard) {
        this.renderProductCard()
        // this.changeProductCardForm()
      } else {
        this.toggleAddButton(false, '', true)
      }
    }
  }

  checkPauseVariants () {
    const frameID = new URLSearchParams(window.location.search).get('frame_id')
    const artistSelected = this.dataset.pauseArtistSelected
    if (!frameID || (artistSelected === 'true' && !this.pauseInfo.featured_frames.includes(Number(frameID))) || (this.pauseInfo.featured_frames.includes(Number(frameID)) && artistSelected === '')) {
      this.toggleAddButton(true, window.variantStrings.unavailable, true)
    }
  }

  updateOptions () {
    // selects
    // if (this.querySelectorAll('select'))
    const selects = Array.from(this.querySelectorAll('select'), (select) => select.value)
    // buttons
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    const radios = (fieldsets.map((fieldset) => {
      const radioInput = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
      if (radioInput) {
        return radioInput.value
      }
      return undefined
    }))

    this.options = selects.concat(radios)
    // this.options = options
  }

  getVariantData (variantData) {
    // console.log('getting variant data')
    // console.log(variantData)
    this.variantData = this.variantData || JSON.parse(this.querySelector('#product-json').textContent)
    // console.log('variant:', this.variantData)
    return this.variantData
  }

  updateMasterId () {
    // console.log('updating master id')
    this.currentVariant = this.getVariantData().find((variant) => {
      // console.log('variant', variant, variant.options)
      return !variant.options.map((option, index) => {
        return this.options[index] === option
      }).includes(false)
    })
  }

  updateURL () {
    const frameNum = new URLSearchParams(window.location.search).get('frame')
    if (!this.currentVariant) return
    if (frameNum) {
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}&frame=${frameNum}`)
    } else {
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
  }

  updateMedia () {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return

    const previewImageSrc = this.currentVariant.featured_media.preview_image.src.split('//')[1]
    // Fire event for carousel to listen to
    const variantSelectedEvent = new CustomEvent('umg:variant:change', {
      detail: {
        variantId: this.currentVariant.id,
        previewImageSrc,
        sectionId: this.dataset.section
      }
    })
    document.dispatchEvent(variantSelectedEvent)
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, div[id^='product-form-']`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      // console.log(input)
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updateSelectedVariantIdFlexibleBundleProductCard () {
    const productCard = this.closest('.flexible-bundle-group__component')
    if (productCard) {
      productCard.dataset.selectedVariantid = this.currentVariant.id
      this.updatePricesOfFlexibleBundleProductCard(productCard)
      document.dispatchEvent(new CustomEvent('umg:flexible-bundle:variant:change', {
        detail: { productCard }
      }))
    }
  }

  updatePricesOfFlexibleBundleProductCard (productCard) {
    const productPriceElement = productCard.querySelector('.price__current')
    const productCompareAtPriceElement = productCard.querySelector('.price__compare')

    const productVariantPrices = JSON.parse(productCard.dataset.price)
    const productVariantPrice = productVariantPrices[this.currentVariant.id]

    if (productVariantPrice) {
      productPriceElement.textContent = formatMoney(productVariantPrice)
    }

    if (productCompareAtPriceElement) {
      const productVariantCompareAtPrices = JSON.parse(productCard.dataset.compareAtPrice)
      const productVariantCompareAtPrice = productVariantCompareAtPrices[this.currentVariant.id]

      if (productVariantCompareAtPrice) {
        productCompareAtPriceElement.textContent = formatMoney(productVariantCompareAtPrice)
      }
    }
  }

  renderProductInfo () {
    // console.log('running variant change')
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const selectors = [
          `#ProductInfo-${this.dataset.section}`,
          `.tags-wrapper`
        ]
        for (const selector of selectors) {
          const source = html.querySelector(selector)
          let destination
          if (this.templateProductWrapper) {
            destination = this.templateProductWrapper.querySelector(selector)
          } else if (this.productWrapper) {
            destination = this.productWrapper.querySelector(selector)
          }
          if (source && destination) destination.innerHTML = source.innerHTML
        }

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init()
        }

        // This event is listened by pause-detail-page to go through the 'checkPauseVariants' function and update pdp atc button state
        const variantChangedEvent = new CustomEvent('umg:variant:changed', {
          detail: {
            variantId: this.currentVariant.id,
            sectionId: this.dataset.section
          }
        })
        document.dispatchEvent(variantChangedEvent)
        this.productInfo.classList.remove('loading')
      })
  }

  renderProductCard () {
    fetch(`${window.origin}/products/${this.dataset.producthandle}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const source = html.querySelector('.template-product product-form')
        const destination = this.closest('.product_card').querySelector('product-form')

        // Reinitiliazes the umg-dates web component to ensure the dates are updated correctly once a user clicks on a different variant (done by replacing the umg-dates in destination with the one in source)
        if (source.querySelector('product-form umg-dates') && destination.querySelector('product-form umg-dates')) {
          destination.querySelector('product-form umg-dates').replaceWith(source.querySelector('product-form umg-dates'))
        }

        // Makes sure that the inputs with the date classes are not removed/replaced so that umg-dates will work correctly
        const classesToExclude = new Set(['promise-msg', 'date-fixed', 'date-fixed-unix', 'date-rolling', 'date-rolling-unix'])

        // Removes all the inputs (excluding inputs with the classes in classesToExclude)
        const sourceFormInputs = Array.from(source.querySelectorAll('input[type="hidden"]')).filter(inputElement => !Array.from(inputElement.classList).some(className => classesToExclude.has(className)))
        destination.querySelectorAll('input[type="hidden"]').forEach(e => {
          if (!Array.from(e.classList).some(className => classesToExclude.has(className))) {
            e.remove()
          }
        })

        if (this.cartUpsellPrice) {
          const variantPrice = html.querySelector('.template-product__wrapper .price-item--regular')
          if (variantPrice) {
            this.cartUpsellPrice.innerHTML = variantPrice.innerHTML
          }
        }

        const destinationForm = destination.querySelector('form')
        const cardSubmitButton = destination.querySelector('.product-form__submit')

        // Adds the inputs from source back in
        for (let i = 0; i < sourceFormInputs.length; i++) {
          const sourceInput = sourceFormInputs[i]
          // destination.querySelector('form').append(sourceInput)
          destinationForm.insertBefore(sourceInput, cardSubmitButton)
        }
        if (source.getAttribute('data-variant')) {
          destination.setAttribute('data-variant', source.getAttribute('data-variant'))
        }

        if (source.querySelector('.product-form__sold-out') || source.querySelector('.product-form__cta-link-wrapper')) {
          // console.log('running?')
          if (destination.querySelector('.product-form__sold-out')) {
            // already exists - just need to show it
            // console.log('showing sold out')
            destination.querySelector('.product-form__sold-out').classList.remove('!hidden')
          } else if (destination.querySelector('.product-form__cta-link-wrapper')) {
            // console.log('showing view product')
            // console.log(destination)
            const CTAs = destination.querySelectorAll('.product-form__cta-link-wrapper')
            CTAs.forEach(cta => {
              cta.classList.add('!hidden')
            })
            destination.querySelector('.product-form__cta-link-wrapper').classList.remove('!hidden')
          } else {
            // console.log('creating sold out or view product')
            // doesn't exist - create
            // source.querySelector('.product-form__sold-out').insertBefore(destination.querySelector('.product-form__submit'))
            if (source.querySelector('.product-form__cta-link-wrapper')) {
              // soldOut.classList.remove('w-full')
              // soldOut.innerHTML = destination.querySelector('.product-form__cta-link-wrapper').innerHTML
              const linkToPdpBtn = source.querySelector('.product-form__cta-link-wrapper')

              linkToPdpBtn.classList.remove('!hidden')
              destinationForm.append(linkToPdpBtn, cardSubmitButton)
            } else {
              const soldOut = source.querySelector('.product-form__sold-out')
              soldOut.classList.remove('!hidden')
              destinationForm.append(soldOut, cardSubmitButton)
            }
          }
          if (destination.querySelector('.product-form__submit')) {
            destination.querySelector('.product-form__submit').classList.add('!hidden')
          }
        } else {
          destination.querySelector('.product-form__submit').classList.remove('!hidden')
          if (destination.querySelector('.product-form__sold-out')) {
            destination.querySelector('.product-form__sold-out').classList.add('!hidden')
          }
          if (destination.querySelector('.product-form__cta-link-wrapper')) {
            destination.querySelector('.product-form__cta-link-wrapper').classList.add('!hidden')
          }
        }
      })
      .finally(() => (
        this.productCard.classList.remove('loading')
      ))
      // })
  }

  changeProductCardForm () {
    // console.log(this.productCard)
    // console.log(this.dataset)
  }

  toggleAddButton (disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      if (text) addButton.querySelector('.buybutton_label').textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButton.querySelector('.buybutton_label').textContent = window.variantStrings.addToCart
    }
  }

  setUnavailable () {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]')
    if (addButton) {
      addButton.querySelector('.buybutton_label').textContent = window.variantStrings.soldOut
      document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden')
    }
    this.productInfo.classList.remove('loading')
  }
}

if (!customElements.get('variant-selector')) {
  customElements.define('variant-selector', VariantSelector)
}
